import styled from "styled-components";

import { alpha, flexColumn, lineClamp, rem } from "@styles/Utilities.styled";


export const StyledPatientNotesModalContent = styled.div`
  height: 100%;

  .new-note {
    height: 100%;
  }
`;

export const StyledNoteCard = styled.button`
  text-align: left;
  ${flexColumn}
  border-radius: var(--border-radius-3);
  border: 1px solid ${alpha("var(--clr-black)", 0.1)};
  padding: 1.5rem 1rem;
`;

export const StyledDescription = styled.p`
  ${lineClamp(2)}
  font-size: ${rem(14)};
  line-height: 1.4;
  margin-top: 0.5rem;
  color: var(--mantine-color-gray-6);
`;
